export function getMonthsUntilNextApril() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  const nextAprilYear =
    currentMonth > 3 || (currentMonth === 3 && currentDay >= 2) ? currentYear + 1 : currentYear;

  const diffMonths = (nextAprilYear - currentYear) * 12 + (3 - currentMonth);

  if (currentMonth === 3 && currentDay < 2) {
    return 0;
  }

  return diffMonths;
}

export function calculateTotalCostForMonth(
  monthNum: number,
  details: Array<{
    free_months: number;
    monthly_price: number;
    first_charge?: number;
  }>,
  monthsUntilNextApril: number,
  annualIncrease: number,
): number {
  const isSingleMonthProduct = details.every(
    (detail) => detail.free_months === 0 && monthsUntilNextApril === 0,
  );
  if (isSingleMonthProduct && monthNum > 1) {
    return 0;
  }

  const baseTotal = details.reduce((total, detail) => {
    const { free_months, monthly_price, first_charge } = detail;

    if (monthNum <= free_months) {
      return total;
    }

    const monthCharge = monthNum === 1 ? (first_charge || 0) + monthly_price : monthly_price;

    return total + monthCharge;
  }, 0);

  const appliedIncrementsCount =
    (monthNum > monthsUntilNextApril ? 1 : 0) + (monthNum > monthsUntilNextApril + 12 ? 1 : 0);

  return baseTotal + appliedIncrementsCount * annualIncrease;
}
